import $ from 'jquery'; 

export default function loader(state)
{
    if (state == 'show') {
        $('.loader').show()
        $('#pageOverlay').show()
        $('body').addClass('overflowHidden');
      } else {
        setTimeout(() => {
          $('.loader').hide()
          $('#pageOverlay').hide()
          $('body').removeClass('overflowHidden');
        }, 500);
      }
}